import { useState } from 'react'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../constants/mfa.setup.steps'

// `prepareRegistration` and `finishRegistration` are the consuming app's own
// API calls. They resolve to `undefined` when the app is already redirecting
// (e.g. an expired session), in which case the flow just stops.
export function useSetupMFATOTP({
  isFromSettings = false,
  prepareRegistration,
  finishRegistration,
}) {
  const [state, setState] = useState({
    step: START_REGISTRATION,
    isFromSettings,
    isProcessing: false,
    errorCode: null,
    registrationData: null,
  })

  const prepare = async () => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      const response = await prepareRegistration()
      if (!response) return
      const { totp_registration_uri: uri, totp_registration_token: token } =
        response
      setState((s) => ({
        ...s,
        isProcessing: false,
        registrationData: { uri, token },
        step: REGISTER,
      }))
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
    }
  }

  const finish = async ({ registrationToken, otp }) => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      await finishRegistration({
        totp_registration_token: registrationToken,
        otp,
      })
      setState((s) => ({
        ...s,
        isProcessing: false,
        step: REGISTRATION_COMPLETE,
      }))
      return true
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
      return false
    }
  }

  return { ...state, prepare, finish }
}
